import { Heading } from "@chakra-ui/react";

const SubTitle = (props: any) => {
    return (
        <Heading
            fontSize={"1rem"}
            fontWeight="semibold"
            mt={props.mt ? props.mt : "0rem"}
            mb={props.mb ? props.mb : "1rem"}
        >
            {props.children}
        </Heading>
    );
};

export default SubTitle;
